module.exports = __webpack_public_path__ + "static/financial-access-desktop.80450774.webp";